import React from "react";
import { MDBRow, MDBCol } from 'mdb-react-ui-kit';

export default function Mutuo({
    setInfoAggiuntive,

    setImportoMutuo,
    setNomeBanca,
    setValoreIscrizioneIpotecaria,

    }) {

	return (
		<>  
            <MDBRow>
                <MDBCol>
                <div className="field">
                    <label className='customLab' for="from_name">Importo del mutuo richiesto ?</label>
                    <input type="number" placeholder="300000" name="importoMutuo" id="importoMutuo" onChange={e => setImportoMutuo(e.target.value)} />
                </div>
                </MDBCol>
                <MDBCol>
                <div className="field">
                    <label className='customLab' >Nome della banca ?</label>
                    <input type="text" placeholder="Banca XXX" name="nomeBanca" id="nomeBanca" onChange={e => setNomeBanca(e.target.value)} />
                </div>
                </MDBCol>
            </MDBRow>

            <MDBRow>
                <MDBCol>
                <div className="field">
                    <label className='customLab' >Valore dell'iscrizione ipotecaria ? </label>
                    <select onChange={e => setValoreIscrizioneIpotecaria(e.target.value)} className="select">
                        <option default value="Scegliere">Non so</option>
                        <option value='150%'>150%</option>
                        <option value='200%'>200%</option>
                        <option value='Altro'>Altro</option>
                    </select>
                </div>
                </MDBCol>
            </MDBRow>

            <MDBRow>
                <div className="field">
                    <label className='customLab' for="message">Informazioni aggiuntive</label>
                    <textarea className="message-field" type="textarea" placeholder="Informazioni" name="infoaggiuntive" id="infoaggiuntive" onChange={e => setInfoAggiuntive(e.target.value)} />
                </div>
            </MDBRow>
            </>
	);
}